/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from '@tanstack/react-query';
import { fetcher } from '@udemy/graphql';

/** All built-in and custom scalars, mapped to their actual values */

/** Price option for computed price plan. Will be returned for annual plans */

/** An API client */

/** Response from creating an API client containing ApiClient info and client's secret */

/** Response from deleting an API client containing the deleted API Client ID */

/** An API client for an Organization */

/** An API client for a Partner */

/** Input for creating an API client */

/** Article lecture */

/**
 * An Assessment represents a collection of Forms (which are variations of items and orderings of items).
 * A user chooses to take an Assessment. They are then give a Form to take from that Assessment.
 */

/** A unique assignment of an assessment to a user, with optional due date */

/** An AssessmentItem contains data about the item a user can interact with. */

/** An  AssessmentItemAttempt is an item related to an Assessment that contains how a user performed in an AssessmentItem. */

/** Contains the valid item attempt status for an item attempt. */
export let AssessmentItemAttemptStatus = /*#__PURE__*/function (AssessmentItemAttemptStatus) {
  AssessmentItemAttemptStatus["Correct"] = "CORRECT";
  AssessmentItemAttemptStatus["Incorrect"] = "INCORRECT";
  AssessmentItemAttemptStatus["Skipped"] = "SKIPPED";
  return AssessmentItemAttemptStatus;
}({});

/** Filters used to fetch user assessment items results that are correct, skipped and attempted. */

/** MetaData for an assessment */

/**
 * An AssessmentResults represents a user results for taking an Assessment.
 * items are the attempts of the latest form the User attempted for an Assessment.
 */

/** List of Assessment and additional data about search response */

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */

/**
 * A 'variant' is an instance/representation of an assessment used for having its own dynamic list of questions
 *
 * There may exist multiple variants of the same assessment, which share the same pool of questions, uniquely ordered between variants. Each variant will have a unique id, and will be associated with one assessment from which the questions are drawn.
 */

/** Top level object to track the progress and results of a user taking an assessment variant */

/** An evaluation of a completed attempt */

/** Lecture in the form of just audio (deprecated) */

/** Issued Badge of a user (Assertion in OpenBadge specification) */

/** Response for storing assertion (which is given as external url) for current user */

/** Response for deleting assertion of current user */

/** Issued badges of a user (Assertion in OpenBadge specification) */

/** Search filters for Badge Assertion search */

/** Certification Provider (topic descriptor) for Open Badges */

/** Certification Subject Area (topic descriptor) for Open Badges */

/** The BadgeClass object. A collection of information about the accomplishment recognized by the Open Badge. It means Certification for the most cases. */

/** Alignment object. An intangible item that describes an alignment between a learning resource and a BadgeClass */

/** Descriptive metadata about the achievements necessary to be issued with particular BadgeClass (Certification). */

/** Enrolled learning products for a badge class */

/** Image object of BadgeClass or Issuer */

/** Issuer of BadgeClass. A collection of information that describes the entity or organization */

/** Search filters for BadgeClass search */

/** Paginated list of BadgeClasses for search response */

/** Wrapped response type for BadgeClass mutations */

/** Input for updating a badge classes by topicId */

/** Input for updating a badge classes by visibilityStatus */

/** Visibility of the badge class on the Udemy platform */
export let BadgeClassVisibilityStatus = /*#__PURE__*/function (BadgeClassVisibilityStatus) {
  BadgeClassVisibilityStatus["Deleted"] = "DELETED";
  BadgeClassVisibilityStatus["Hidden"] = "HIDDEN";
  BadgeClassVisibilityStatus["InstructorIssued"] = "INSTRUCTOR_ISSUED";
  BadgeClassVisibilityStatus["Organization"] = "ORGANIZATION";
  BadgeClassVisibilityStatus["Pending"] = "PENDING";
  BadgeClassVisibilityStatus["Visible"] = "VISIBLE";
  return BadgeClassVisibilityStatus;
}({});

/** Types of captions */
export let CaptionType = /*#__PURE__*/function (CaptionType) {
  CaptionType["ClosedCaption"] = "CLOSED_CAPTION";
  CaptionType["Subtitle"] = "SUBTITLE";
  return CaptionType;
}({});

/** Category the Course belongs to */

/** URL to the exam registration page for a certification with its locale */

/** Type of the files withing coding exercise templates */

/** Coding exercise for students to practice their programming */

/** Language possibilities for a coding exercise */
export let CodingExerciseLanguageOption = /*#__PURE__*/function (CodingExerciseLanguageOption) {
  CodingExerciseLanguageOption["Cplusplus"] = "CPLUSPLUS";
  CodingExerciseLanguageOption["Cplusplus_20"] = "CPLUSPLUS_20";
  CodingExerciseLanguageOption["CsvProcessingWithPython"] = "CSV_PROCESSING_WITH_PYTHON";
  CodingExerciseLanguageOption["CSharp"] = "C_SHARP";
  CodingExerciseLanguageOption["CSharp_11"] = "C_SHARP_11";
  CodingExerciseLanguageOption["Html"] = "HTML";
  CodingExerciseLanguageOption["JavascriptEs6"] = "JAVASCRIPT_ES6";
  CodingExerciseLanguageOption["Java_9"] = "JAVA_9";
  CodingExerciseLanguageOption["Java_11"] = "JAVA_11";
  CodingExerciseLanguageOption["Java_17"] = "JAVA_17";
  CodingExerciseLanguageOption["Kotlin_1_9"] = "KOTLIN_1_9";
  CodingExerciseLanguageOption["Php_5"] = "PHP_5";
  CodingExerciseLanguageOption["Php_7"] = "PHP_7";
  CodingExerciseLanguageOption["Python_3_5"] = "PYTHON_3_5";
  CodingExerciseLanguageOption["Python_3_8"] = "PYTHON_3_8";
  CodingExerciseLanguageOption["Python_3_10"] = "PYTHON_3_10";
  CodingExerciseLanguageOption["React_16"] = "REACT_16";
  CodingExerciseLanguageOption["React_18"] = "REACT_18";
  CodingExerciseLanguageOption["Ruby"] = "RUBY";
  CodingExerciseLanguageOption["R_3_6"] = "R_3_6";
  CodingExerciseLanguageOption["Scipy_1_4NumpyPandasSympyAndScikitLearn_0_23"] = "SCIPY_1_4_NUMPY_PANDAS_SYMPY_AND_SCIKIT_LEARN_0_23";
  CodingExerciseLanguageOption["Sql"] = "SQL";
  CodingExerciseLanguageOption["Sqlite_3"] = "SQLITE_3";
  CodingExerciseLanguageOption["Swift_3"] = "SWIFT_3";
  CodingExerciseLanguageOption["Swift_5"] = "SWIFT_5";
  CodingExerciseLanguageOption["WebDevelopment"] = "WEB_DEVELOPMENT";
  return CodingExerciseLanguageOption;
}({});

/** Type of the coding exercise templates */

/** Filtration options for the coding exercise templates */

/** The cohort path object. */

/** The type of activity within a section */
export let CohortPathActivityResourceType = /*#__PURE__*/function (CohortPathActivityResourceType) {
  CohortPathActivityResourceType["Assignment"] = "ASSIGNMENT";
  CohortPathActivityResourceType["CodingExercise"] = "CODING_EXERCISE";
  CohortPathActivityResourceType["Lecture"] = "LECTURE";
  CohortPathActivityResourceType["PracticeTest"] = "PRACTICE_TEST";
  CohortPathActivityResourceType["Quiz"] = "QUIZ";
  return CohortPathActivityResourceType;
}({});

/** The cohort path course library object. */

/** Input for cohort path creation or update. */

/** Response for creating or updating cohort path. */

/** The cohort path section object. */

/** Base type for the cohort path section activity object. */

/** The cohort path section activity input object. */

/** The cohort path section activity object. */

/** The cohort path section input object. */

/** Input for cohort path sections update. */

/** Response for updating cohort path sections. */

/** Paginated cohort path object. */

/** Type representing a group of content for a subscription plan */

/** The Course object. */

/** Accreditations */

/** Accreditation types */
export let CourseAccreditationType = /*#__PURE__*/function (CourseAccreditationType) {
  CourseAccreditationType["Cpe"] = "CPE";
  return CourseAccreditationType;
}({});

/** Course caption details such as locale, type, and source */

/** A catalog of all courses available to the client */

/** Changes to catalog of all courses available to the client */

/** Category the Course belongs to */

/** Enrollments belonging to the course */

/** Course images by varying dimensions */

/** Instructor for a course */

/** Organization specific course properties */

/** Object to store URL and expiration time for course's promo video */

/** Ratings of a course */

/** Search filters to apply on search request */

/** List of Courses and additional data about search response */

/** Sort order for courses in search response */
export let CourseSearchSortType = /*#__PURE__*/function (CourseSearchSortType) {
  CourseSearchSortType["Rating"] = "RATING";
  CourseSearchSortType["Relevance"] = "RELEVANCE";
  CourseSearchSortType["Reviews"] = "REVIEWS";
  CourseSearchSortType["Time"] = "TIME";
  return CourseSearchSortType;
}({});

/** Section of the course containing all types of curriculum items */

/** Response for create snapshot */

/** SubCategory that is part of CourseCategory */

/** Currencies available */
export let CurrencyCode = /*#__PURE__*/function (CurrencyCode) {
  CurrencyCode["Aud"] = "AUD";
  CurrencyCode["Brl"] = "BRL";
  CurrencyCode["Cad"] = "CAD";
  CurrencyCode["Clp"] = "CLP";
  CurrencyCode["Cop"] = "COP";
  CurrencyCode["Dkk"] = "DKK";
  CurrencyCode["Egp"] = "EGP";
  CurrencyCode["Eur"] = "EUR";
  CurrencyCode["Gbp"] = "GBP";
  CurrencyCode["Idr"] = "IDR";
  CurrencyCode["Ils"] = "ILS";
  CurrencyCode["Inr"] = "INR";
  CurrencyCode["Jpy"] = "JPY";
  CurrencyCode["Krw"] = "KRW";
  CurrencyCode["Mxn"] = "MXN";
  CurrencyCode["Myr"] = "MYR";
  CurrencyCode["Ngn"] = "NGN";
  CurrencyCode["Nok"] = "NOK";
  CurrencyCode["Pen"] = "PEN";
  CurrencyCode["Php"] = "PHP";
  CurrencyCode["Pln"] = "PLN";
  CurrencyCode["Ron"] = "RON";
  CurrencyCode["Rub"] = "RUB";
  CurrencyCode["Sgd"] = "SGD";
  CurrencyCode["Thb"] = "THB";
  CurrencyCode["Try"] = "TRY";
  CurrencyCode["Twd"] = "TWD";
  CurrencyCode["Usd"] = "USD";
  CurrencyCode["Vnd"] = "VND";
  CurrencyCode["Zar"] = "ZAR";
  return CurrencyCode;
}({});

/** Curriculum part of a course */

/** Interface for a curriculum item */

/** Price option for computed price plan. Will be returned for daily plans */

/** Filter used to pass start and end date between which learning activity has to be returned. Date range should be less than or equal to 120 days when granularity is DAY level. */

/** Type representing details about an interval of dates */

/** Supported units of time over which a subscription trial or billing cycle can occur */
export let DateIntervalType = /*#__PURE__*/function (DateIntervalType) {
  DateIntervalType["Day"] = "DAY";
  DateIntervalType["Month"] = "MONTH";
  DateIntervalType["Week"] = "WEEK";
  DateIntervalType["Year"] = "YEAR";
  return DateIntervalType;
}({});

/** Instruction level of the course */
export let DifficultyLevel = /*#__PURE__*/function (DifficultyLevel) {
  DifficultyLevel["AllLevels"] = "ALL_LEVELS";
  DifficultyLevel["Beginner"] = "BEGINNER";
  DifficultyLevel["Expert"] = "EXPERT";
  DifficultyLevel["Intermediate"] = "INTERMEDIATE";
  return DifficultyLevel;
}({});

/** definition of different discount source types */
export let DiscountSourceType = /*#__PURE__*/function (DiscountSourceType) {
  DiscountSourceType["GeneralCoupon"] = "GENERAL_COUPON";
  DiscountSourceType["InstructorCoupon"] = "INSTRUCTOR_COUPON";
  DiscountSourceType["UdemyCoupon"] = "UDEMY_COUPON";
  return DiscountSourceType;
}({});

/** DiscussionEntry represents a piece user-created content in context of discussion */

/** A discussion entry input type for creating and updating discussion entries i.e. Posts, Comments, etc. */

/** The content of a component defined in the CMS */

/** The dynamic web content query filter options */

/** The dynamic web image object. This combines the image URL and the alt text for the image for a11y purposes. */

/** The specific page type for the dynamic web content. This is important for narrowing down the content in the CMS to where Marketing wants to render it. */
export let DynamicWebContentPageType = /*#__PURE__*/function (DynamicWebContentPageType) {
  DynamicWebContentPageType["LoggedOutHomePage"] = "LOGGED_OUT_HOME_PAGE";
  DynamicWebContentPageType["PersonalPlanLandingPage"] = "PERSONAL_PLAN_LANDING_PAGE";
  DynamicWebContentPageType["RequestDemoForm"] = "REQUEST_DEMO_FORM";
  return DynamicWebContentPageType;
}({});

/** Lecture in form of an EBook (deprecated) */

/** A record of user's enrollment to a learning product */

/** Response object for enrollment creation */

/** Input for enrolling to learning product */

/** Learning product type input */
export let EnrollmentsLearningProductInputType = /*#__PURE__*/function (EnrollmentsLearningProductInputType) {
  EnrollmentsLearningProductInputType["Course"] = "COURSE";
  return EnrollmentsLearningProductInputType;
}({});

/** Lecture that refers to an external source (deprecated) */

/** Stores realtime attribute like build_number->20220322_v1 */

/** Holds assigned feature variant  */

/** Holds filters for feature variant assignments */

/** Feedback object */

/** Input to create Feedback */

/** Response for storing a feedback */

/** Polymorphic object to represent what the feedback is being applied to */

/** Possible feedback options */
export let FeedbackOption = /*#__PURE__*/function (FeedbackOption) {
  FeedbackOption["Negative"] = "NEGATIVE";
  FeedbackOption["Positive"] = "POSITIVE";
  FeedbackOption["Unselected"] = "UNSELECTED";
  return FeedbackOption;
}({});

/** Possible object targets to apply the feedback to */
export let FeedbackTargetType = /*#__PURE__*/function (FeedbackTargetType) {
  FeedbackTargetType["CourseSection"] = "COURSE_SECTION";
  FeedbackTargetType["LearningAssistantChatMessage"] = "LEARNING_ASSISTANT_CHAT_MESSAGE";
  FeedbackTargetType["Lecture"] = "LECTURE";
  return FeedbackTargetType;
}({});

/** Lecture in the form of a single file (deprecated) */

/** Instructor for a learning product */

/** Instructor's account balance */

/** Instructor's account issues */

/** Instructor images by varying dimensions */

/** Instructor's payout */

/** Instructor's payouts paged */

/** The Lab object. */

/** Instructor for a lab */

/** MetaData for a lab */

/** List of Labs and additional data about search response */

/** The LanguageCode scalar type as defined by ISO 639-1. */
export let LanguageCode = /*#__PURE__*/function (LanguageCode) {
  LanguageCode["Af"] = "AF";
  LanguageCode["Ak"] = "AK";
  LanguageCode["Am"] = "AM";
  LanguageCode["Ar"] = "AR";
  LanguageCode["As"] = "AS";
  LanguageCode["Az"] = "AZ";
  LanguageCode["Be"] = "BE";
  LanguageCode["Bg"] = "BG";
  LanguageCode["Bm"] = "BM";
  LanguageCode["Bn"] = "BN";
  LanguageCode["Bo"] = "BO";
  LanguageCode["Br"] = "BR";
  LanguageCode["Bs"] = "BS";
  LanguageCode["Ca"] = "CA";
  LanguageCode["Ce"] = "CE";
  LanguageCode["Cs"] = "CS";
  LanguageCode["Cu"] = "CU";
  LanguageCode["Cy"] = "CY";
  LanguageCode["Da"] = "DA";
  LanguageCode["De"] = "DE";
  LanguageCode["Dz"] = "DZ";
  LanguageCode["Ee"] = "EE";
  LanguageCode["El"] = "EL";
  LanguageCode["En"] = "EN";
  LanguageCode["Eo"] = "EO";
  LanguageCode["Es"] = "ES";
  LanguageCode["Et"] = "ET";
  LanguageCode["Eu"] = "EU";
  LanguageCode["Fa"] = "FA";
  LanguageCode["Ff"] = "FF";
  LanguageCode["Fi"] = "FI";
  LanguageCode["Fo"] = "FO";
  LanguageCode["Fr"] = "FR";
  LanguageCode["Fy"] = "FY";
  LanguageCode["Ga"] = "GA";
  LanguageCode["Gd"] = "GD";
  LanguageCode["Gl"] = "GL";
  LanguageCode["Gu"] = "GU";
  LanguageCode["Gv"] = "GV";
  LanguageCode["Ha"] = "HA";
  LanguageCode["He"] = "HE";
  LanguageCode["Hi"] = "HI";
  LanguageCode["Hr"] = "HR";
  LanguageCode["Hu"] = "HU";
  LanguageCode["Hy"] = "HY";
  LanguageCode["Ia"] = "IA";
  LanguageCode["Id"] = "ID";
  LanguageCode["Ig"] = "IG";
  LanguageCode["Ii"] = "II";
  LanguageCode["Is"] = "IS";
  LanguageCode["It"] = "IT";
  LanguageCode["Ja"] = "JA";
  LanguageCode["Jv"] = "JV";
  LanguageCode["Ka"] = "KA";
  LanguageCode["Ki"] = "KI";
  LanguageCode["Kk"] = "KK";
  LanguageCode["Kl"] = "KL";
  LanguageCode["Km"] = "KM";
  LanguageCode["Kn"] = "KN";
  LanguageCode["Ko"] = "KO";
  LanguageCode["Ks"] = "KS";
  LanguageCode["Ku"] = "KU";
  LanguageCode["Kw"] = "KW";
  LanguageCode["Ky"] = "KY";
  LanguageCode["Lb"] = "LB";
  LanguageCode["Lg"] = "LG";
  LanguageCode["Ln"] = "LN";
  LanguageCode["Lo"] = "LO";
  LanguageCode["Lt"] = "LT";
  LanguageCode["Lu"] = "LU";
  LanguageCode["Lv"] = "LV";
  LanguageCode["Mg"] = "MG";
  LanguageCode["Mi"] = "MI";
  LanguageCode["Mk"] = "MK";
  LanguageCode["Ml"] = "ML";
  LanguageCode["Mn"] = "MN";
  LanguageCode["Mr"] = "MR";
  LanguageCode["Ms"] = "MS";
  LanguageCode["Mt"] = "MT";
  LanguageCode["My"] = "MY";
  LanguageCode["Nb"] = "NB";
  LanguageCode["Nd"] = "ND";
  LanguageCode["Ne"] = "NE";
  LanguageCode["Nl"] = "NL";
  LanguageCode["Nn"] = "NN";
  LanguageCode["No"] = "NO";
  LanguageCode["Om"] = "OM";
  LanguageCode["Or"] = "OR";
  LanguageCode["Os"] = "OS";
  LanguageCode["Pa"] = "PA";
  LanguageCode["Pl"] = "PL";
  LanguageCode["Ps"] = "PS";
  LanguageCode["Pt"] = "PT";
  LanguageCode["PtBr"] = "PT_BR";
  LanguageCode["PtPt"] = "PT_PT";
  LanguageCode["Qu"] = "QU";
  LanguageCode["Rm"] = "RM";
  LanguageCode["Rn"] = "RN";
  LanguageCode["Ro"] = "RO";
  LanguageCode["Ru"] = "RU";
  LanguageCode["Rw"] = "RW";
  LanguageCode["Sd"] = "SD";
  LanguageCode["Se"] = "SE";
  LanguageCode["Sg"] = "SG";
  LanguageCode["Si"] = "SI";
  LanguageCode["Sk"] = "SK";
  LanguageCode["Sl"] = "SL";
  LanguageCode["Sn"] = "SN";
  LanguageCode["So"] = "SO";
  LanguageCode["Sq"] = "SQ";
  LanguageCode["Sr"] = "SR";
  LanguageCode["Su"] = "SU";
  LanguageCode["Sv"] = "SV";
  LanguageCode["Sw"] = "SW";
  LanguageCode["Ta"] = "TA";
  LanguageCode["Te"] = "TE";
  LanguageCode["Tg"] = "TG";
  LanguageCode["Th"] = "TH";
  LanguageCode["Ti"] = "TI";
  LanguageCode["Tk"] = "TK";
  LanguageCode["To"] = "TO";
  LanguageCode["Tr"] = "TR";
  LanguageCode["Tt"] = "TT";
  LanguageCode["Ug"] = "UG";
  LanguageCode["Uk"] = "UK";
  LanguageCode["Ur"] = "UR";
  LanguageCode["Uz"] = "UZ";
  LanguageCode["Vi"] = "VI";
  LanguageCode["Vo"] = "VO";
  LanguageCode["Wo"] = "WO";
  LanguageCode["Xh"] = "XH";
  LanguageCode["Yi"] = "YI";
  LanguageCode["Yo"] = "YO";
  LanguageCode["Zh"] = "ZH";
  LanguageCode["ZhCn"] = "ZH_CN";
  LanguageCode["ZhTw"] = "ZH_TW";
  LanguageCode["Zu"] = "ZU";
  return LanguageCode;
}({});

/** Represents the learning activity period like daily or monthly and the corresponding date in value. For monthly, day portion in the value will be 1st of the month. */

/** Contains records of time spent in a learning activity */

/** Represents the learning activity in trend view. */

/** Filters used to fetch learning activity. */

/** Input for chat message context */

/** Response for initiating a chat session */

/** Represent learning products that can be shared within a chat message (deprecated) */

/** Represent learning products or curriculum items that can be shared within a chat message */

/** Represent a chat message */

/** Union of possible chat message items */

/** Represents the roles of chat messages */
export let LearningAssistantChatMessageRole = /*#__PURE__*/function (LearningAssistantChatMessageRole) {
  LearningAssistantChatMessageRole["Assistant"] = "ASSISTANT";
  LearningAssistantChatMessageRole["User"] = "USER";
  return LearningAssistantChatMessageRole;
}({});

/** Response for sending a chat message */

/** Paginated chat messages */

/** Represents different types of chat sessions */
export let LearningAssistantChatName = /*#__PURE__*/function (LearningAssistantChatName) {
  LearningAssistantChatName["DiscoveryChat"] = "DISCOVERY_CHAT";
  LearningAssistantChatName["InCourseChat"] = "IN_COURSE_CHAT";
  LearningAssistantChatName["IqgChat"] = "IQG_CHAT";
  LearningAssistantChatName["SkillsChat"] = "SKILLS_CHAT";
  return LearningAssistantChatName;
}({});

/** Represent a text message that can be shared within a chat message */

/** Input for sending a text chat message */

/** Represent a curriculum item that extends an actual curriculum item */

/** Represent a learning assistant-specific learning product that extends an actual learning product */

/** Union of possible chat message item types that can be shared within a chat message item */

/** Prompt suggestions that users can ask the assistant */

/** Represents all pages that supporte displaying suggested prompts */
export let LearningAssistantSuggestedPromptPageSource = /*#__PURE__*/function (LearningAssistantSuggestedPromptPageSource) {
  LearningAssistantSuggestedPromptPageSource["AiAssistantPage"] = "AI_ASSISTANT_PAGE";
  LearningAssistantSuggestedPromptPageSource["CourseLandingPage"] = "COURSE_LANDING_PAGE";
  LearningAssistantSuggestedPromptPageSource["CourseTakingPage"] = "COURSE_TAKING_PAGE";
  LearningAssistantSuggestedPromptPageSource["LoggedInHomePage"] = "LOGGED_IN_HOME_PAGE";
  LearningAssistantSuggestedPromptPageSource["SearchResultsPage"] = "SEARCH_RESULTS_PAGE";
  return LearningAssistantSuggestedPromptPageSource;
}({});

/** Paginated suggested prompts */

/** The Learning Community */

/** A page of Learning Community Activities */

/** An activity is an event initiated by a user */

/** All the activity types presented in a learning community activity feed */

/** The response for updating a learning community activity */

/** The type of reaction that is being added or removed */

/** The type of reaction available to users */
export let LearningCommunityActivityUserReactionType = /*#__PURE__*/function (LearningCommunityActivityUserReactionType) {
  LearningCommunityActivityUserReactionType["Celebrate"] = "CELEBRATE";
  LearningCommunityActivityUserReactionType["Insightful"] = "INSIGHTFUL";
  LearningCommunityActivityUserReactionType["Like"] = "LIKE";
  LearningCommunityActivityUserReactionType["PlusOne"] = "PLUS_ONE";
  return LearningCommunityActivityUserReactionType;
}({});

/** The reactions and the users who reacted to a learning community activity */

/** Response for creating a new Learning Community */

/** The Reason for creating a new Learning Community */

/** The Reason for creating a new Learning Community */

/** The Reasons for creating a new Learning Community */
export let LearningCommunityCreateReasonType = /*#__PURE__*/function (LearningCommunityCreateReasonType) {
  LearningCommunityCreateReasonType["CompanyWideTransformationInitiate"] = "COMPANY_WIDE_TRANSFORMATION_INITIATE";
  LearningCommunityCreateReasonType["ComplianceTraining"] = "COMPLIANCE_TRAINING";
  LearningCommunityCreateReasonType["LearnNewSkillsTogetherWithOthers"] = "LEARN_NEW_SKILLS_TOGETHER_WITH_OTHERS";
  LearningCommunityCreateReasonType["OnboardingANewTeam"] = "ONBOARDING_A_NEW_TEAM";
  LearningCommunityCreateReasonType["Other"] = "OTHER";
  LearningCommunityCreateReasonType["StudyForACertificate"] = "STUDY_FOR_A_CERTIFICATE";
  return LearningCommunityCreateReasonType;
}({});

/** An event happening to a curriculum item which is part of a course */

/** The type of events that happens to a curriculum item */
export let LearningCommunityCurriculumItemEventType = /*#__PURE__*/function (LearningCommunityCurriculumItemEventType) {
  LearningCommunityCurriculumItemEventType["Completed"] = "COMPLETED";
  return LearningCommunityCurriculumItemEventType;
}({});

/** Response for deleting a Learning Community */

/** The input used for creating a new Learning Community */

/** The input used for inviting new members to the learning community */

/** A post in a learning community activity feed */

/** The response for creating a new post in the learning community activity feed */

/** A post event happening in a learning community activity feed */

/** The visibility of the learning community */
export let LearningCommunityVisibility = /*#__PURE__*/function (LearningCommunityVisibility) {
  LearningCommunityVisibility["Private"] = "PRIVATE";
  LearningCommunityVisibility["Public"] = "PUBLIC";
  return LearningCommunityVisibility;
}({});

/** A learning objective is a brief statements that describe what students will be expected to learn. */

/** Represents the types of activities we can map to a Learning Objective. */

/** Allows the user to set the activity id's and the activity types they want to query for. */

/** Represent the types of activities we can map to a Learning Objective. */
export let LearningObjectiveActivityTypeInput = /*#__PURE__*/function (LearningObjectiveActivityTypeInput) {
  LearningObjectiveActivityTypeInput["AssessmentQuestion"] = "ASSESSMENT_QUESTION";
  LearningObjectiveActivityTypeInput["Lab"] = "LAB";
  LearningObjectiveActivityTypeInput["LabTask"] = "LAB_TASK";
  LearningObjectiveActivityTypeInput["Lecture"] = "LECTURE";
  return LearningObjectiveActivityTypeInput;
}({});

/** This holds data to create a learning objective */

/** The learning path object. */

/** Response for creating/updating a learning path from skills */

/** Instructor for a Learning Path */

/** Search filters to apply on path search request */

/** List of LearningPath and additional data about search response */

/** All partner's content collection items that are available, currently just course */

/** An event happening to a learning product in a moment in time */

/** The type of events that happens to a learning product and matters to the learning community service */
export let LearningProductEventType = /*#__PURE__*/function (LearningProductEventType) {
  LearningProductEventType["Completed"] = "COMPLETED";
  LearningProductEventType["Enrolled"] = "ENROLLED";
  LearningProductEventType["Started"] = "STARTED";
  return LearningProductEventType;
}({});

/** Input for getting badge classes by learning products */

/** Type of learning product. */
export let LearningProductType = /*#__PURE__*/function (LearningProductType) {
  LearningProductType["Assessment"] = "ASSESSMENT";
  LearningProductType["Course"] = "COURSE";
  LearningProductType["Lab"] = "LAB";
  LearningProductType["LearningPath"] = "LEARNING_PATH";
  return LearningProductType;
}({});

/** A collection of learning products for a partner */

/** The LearningReminder object. */

/** Calendar type of the learning reminder */
export let LearningReminderCalendarType = /*#__PURE__*/function (LearningReminderCalendarType) {
  LearningReminderCalendarType["Apple"] = "APPLE";
  LearningReminderCalendarType["Google"] = "GOOGLE";
  LearningReminderCalendarType["Other"] = "OTHER";
  LearningReminderCalendarType["Outlook"] = "OUTLOOK";
  return LearningReminderCalendarType;
}({});

/** Response for creating or updating a learning reminder */

/** Response for deleting a learning reminder */

/** Input for creating and updating a learning reminder */

/** Input for learning product of the learning reminder */

/** Notification method of the learning reminder */
export let LearningReminderNotificationMethod = /*#__PURE__*/function (LearningReminderNotificationMethod) {
  LearningReminderNotificationMethod["Email"] = "EMAIL";
  LearningReminderNotificationMethod["Push"] = "PUSH";
  return LearningReminderNotificationMethod;
}({});

/** Paginated learning reminders of the user */

/** The testimonial given relevant to a learning item or event */

/** The Learning Testimonials query filter options */

/** The specific page type for the Learning Testimonial. This is important for narrowing down the testimonial content in the CMS to where Marketing wants to render it. (Other pages will be added in the future, e.g., Personal Plan, etc) */
export let LearningTestimonialPageType = /*#__PURE__*/function (LearningTestimonialPageType) {
  LearningTestimonialPageType["LoggedOutHomePage"] = "LOGGED_OUT_HOME_PAGE";
  return LearningTestimonialPageType;
}({});

/** The source of the learning testimonial */

/** Type of Learning Testimonial */
export let LearningTestimonialType = /*#__PURE__*/function (LearningTestimonialType) {
  LearningTestimonialType["CaseStudy"] = "CASE_STUDY";
  LearningTestimonialType["CourseReview"] = "COURSE_REVIEW";
  LearningTestimonialType["ThirdParty"] = "THIRD_PARTY";
  return LearningTestimonialType;
}({});

/** Represents a lecture type  */

/** Lecture images by varying dimensions */

/** List of LectureResults and additional data about search response */

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */

/** Identifies each result for lecture search. */

/** License pool */

/** Count of Active Users per Product Type per License Pool */

/** Response for a license pool create or update mutation */

/** Response for a license pool delete mutation */

/** The input used for creating and updating a license pool */

/** Product type license count */

/** The input used for describing a product type license count */

/** Response for License Pool users move mutation */

/** License Pools users per SubscriptionPlanProductType of the pool */

/** Filters for the License Pools queries */

/** Money */

/** Price option for computed price plan. Will be returned for monthly plans */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Root mutation from which every mutation schema extends */

/** Details of Occupation */

/** User is assigning occupation to themself */

/** Occupation group type */

/** Current user assigning existing occupation group. */

/** Shows page search results of occupation */

/** Current user assigning user provided occupation. */

/** Filters for occupation search */

/** A UB organization */

/** Represents the each organization notification preference */

/** Represents the notification preferences of an organization */

/** Represents the organization notification save response */

/** Role-based organization notifications to group organization notifications by role */
export let OrganizationNotificationRoleType = /*#__PURE__*/function (OrganizationNotificationRoleType) {
  OrganizationNotificationRoleType["Everyone"] = "EVERYONE";
  OrganizationNotificationRoleType["GroupAdmins"] = "GROUP_ADMINS";
  OrganizationNotificationRoleType["Learners"] = "LEARNERS";
  return OrganizationNotificationRoleType;
}({});

/** A notification preference belongs to organization */

/** Object that describes the type and status of license assigned to a user in an organization */

/** Object that describes the status of license assigned to a user in an organization */
export let OrganizationUserLicenseStatus = /*#__PURE__*/function (OrganizationUserLicenseStatus) {
  OrganizationUserLicenseStatus["Active"] = "ACTIVE";
  OrganizationUserLicenseStatus["Inactive"] = "INACTIVE";
  return OrganizationUserLicenseStatus;
}({});

/** Object that describes the type of license assigned to a user in an organization */
export let OrganizationUserLicenseType = /*#__PURE__*/function (OrganizationUserLicenseType) {
  OrganizationUserLicenseType["Basic"] = "BASIC";
  OrganizationUserLicenseType["Pro"] = "PRO";
  return OrganizationUserLicenseType;
}({});

/** Filters for the organizationUserLicenses query */

/** Interface for implementing paginated results */

/** A Partner */

/** Contains info for front end related stuff and tracking info. This data is calculated by backend service and used by Udemy front end. If you are an external user, you shouldn't need this. */

/** Enum for different payment method types */
export let PaymentMethodType = /*#__PURE__*/function (PaymentMethodType) {
  PaymentMethodType["Cheque"] = "CHEQUE";
  PaymentMethodType["Jpmorgan"] = "JPMORGAN";
  PaymentMethodType["Payoneer"] = "PAYONEER";
  PaymentMethodType["Paypal"] = "PAYPAL";
  PaymentMethodType["Wire"] = "WIRE";
  return PaymentMethodType;
}({});

/** Enum for different payout statuses */
export let PayoutStatusType = /*#__PURE__*/function (PayoutStatusType) {
  PayoutStatusType["Blocked"] = "BLOCKED";
  PayoutStatusType["Cancelled"] = "CANCELLED";
  PayoutStatusType["Failed"] = "FAILED";
  PayoutStatusType["Initial"] = "INITIAL";
  PayoutStatusType["Pending"] = "PENDING";
  PayoutStatusType["Processing"] = "PROCESSING";
  PayoutStatusType["Queuing"] = "QUEUING";
  PayoutStatusType["ReadyToPay"] = "READY_TO_PAY";
  PayoutStatusType["Success"] = "SUCCESS";
  PayoutStatusType["Unclaimed"] = "UNCLAIMED";
  PayoutStatusType["Unpaid"] = "UNPAID";
  return PayoutStatusType;
}({});

/** Popular topic */

/** Topic SubCategory */

/** Assigment test with multiple-choice and free-from questions reviewed by instructors */

/** Practice test that is more detailed than a Quiz */

/** Presentation Lecture for Udemy Business */

/** The Pro learning path object. */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Root query from which every query schema extends */

/** Quiz with simple questions and multiple choice answers */

/** The answer created by the user in response to the given reflection prompt. */

/** Response for creating a Reflection Answer */

/** Response for updating the answer for a Reflection */

/** Variations for searching user reflection responses */

/** Paginated list of user reflection answers for list response */

/** The prompt to be displayed to the user to answer. The prompt is intended to invoke a user response that is not a yes/no but is typically personal to them in context to what is being asked. */

/** The Answer given by the user for reflection prompt */

/** The resource objects in which the user can answer the reflection prompt */

/** The input used for defining the resource in which the user gave the answer */

/** The Types of resources in which the user can answer the reflection prompt */
export let ReflectionResourceType = /*#__PURE__*/function (ReflectionResourceType) {
  ReflectionResourceType["Course"] = "COURSE";
  ReflectionResourceType["LearningCommunity"] = "LEARNING_COMMUNITY";
  return ReflectionResourceType;
}({});

/** A review of a learning product */

/** Identifies available search filter facets. */

/** Options for search aggregates */

/** One of the available options within a search facet type */

/** A simple auto-complete item can be search log, course or instructor */

/** Search Log suggestion for autocomplete */

/** Search Autocomplete request filters */

/** A simple autocomplete item with the tracking metadata */

/** A skills framework is a collection of learning objectives that are organized into a hierarchy. */

/** The goal for a skills framework which contains a set of learning objectives. */
export let SkillsFrameworkGoalType = /*#__PURE__*/function (SkillsFrameworkGoalType) {
  SkillsFrameworkGoalType["Blueprint"] = "BLUEPRINT";
  SkillsFrameworkGoalType["BottomUp"] = "BOTTOM_UP";
  SkillsFrameworkGoalType["OpenBadge"] = "OPEN_BADGE";
  SkillsFrameworkGoalType["OrgUpskill"] = "ORG_UPSKILL";
  return SkillsFrameworkGoalType;
}({});

/** A SkillsFramework Id Input is used to identify a skills framework by id and type. */

/** To save a SkillsFramework we need the name and learning objectives associated with it */

/** Response for mapping content to skills framework task reference id status */

/** Content mapping task id and current mapping task status */

/** Status of map content for a reference Id */
export let SkillsFrameworkMapContentTaskStatus = /*#__PURE__*/function (SkillsFrameworkMapContentTaskStatus) {
  SkillsFrameworkMapContentTaskStatus["Failed"] = "FAILED";
  SkillsFrameworkMapContentTaskStatus["InProgress"] = "IN_PROGRESS";
  SkillsFrameworkMapContentTaskStatus["Killed"] = "KILLED";
  SkillsFrameworkMapContentTaskStatus["Success"] = "SUCCESS";
  return SkillsFrameworkMapContentTaskStatus;
}({});

/** This is the response for updating a skills framework */

/** Details about a user's lecture minutes consumption streak, including what to achieve by what date */

/** Status of any type of streak */
export let StreakStatus = /*#__PURE__*/function (StreakStatus) {
  StreakStatus["ActiveCurrentPeriodAchieved"] = "ACTIVE_CURRENT_PERIOD_ACHIEVED";
  StreakStatus["ActiveCurrentPeriodUnachieved"] = "ACTIVE_CURRENT_PERIOD_UNACHIEVED";
  StreakStatus["Dropped"] = "DROPPED";
  StreakStatus["ZeroHistory"] = "ZERO_HISTORY";
  return StreakStatus;
}({});

/** SubCategory that is part of CourseCategory */

/** Subscription plan that the subscriber is subscribed to */

/** Subscriber of the subscription */

/** Subscriber Type */
export let SubscriberType = /*#__PURE__*/function (SubscriberType) {
  SubscriberType["Organization"] = "ORGANIZATION";
  SubscriberType["User"] = "USER";
  return SubscriberType;
}({});

/** Billing details of a subscription */

/** Credit card used for the subscription */

/** Subscription object that represents consumer and UB subscriptions */

/** Response for subscription enrollment update mutations */

/** Subscription Feature */

/** Subscription Feature Availability */

/** Subscription Feature Key */
export let SubscriptionFeatureKey = /*#__PURE__*/function (SubscriptionFeatureKey) {
  SubscriptionFeatureKey["Groups"] = "GROUPS";
  SubscriptionFeatureKey["Scim"] = "SCIM";
  return SubscriptionFeatureKey;
}({});

/** Subscription Feature Override */

/** Subscription Feature Override Input */

/** Response for the Subscription Feature Set Overrides mutations */

/** Payment method of the subscription */

/** An offer for a consumer subscription plan to access a catalog of Udemy content */

/** An offer for a consumer subscription plan to access a catalog of Udemy content */

/** Contains information about the discount metadata for a given subscription plan price option */

/** Details of the specific discount type */

/** Contains information on the start and end perioid for the discount interval type can be month/year */

/** Discount details for applied discount */

/** enum definition for different discount types for subscription */
export let SubscriptionPlanDiscountType = /*#__PURE__*/function (SubscriptionPlanDiscountType) {
  SubscriptionPlanDiscountType["PlanPriceDiscount"] = "PLAN_PRICE_DISCOUNT";
  SubscriptionPlanDiscountType["TrialDiscount"] = "TRIAL_DISCOUNT";
  return SubscriptionPlanDiscountType;
}({});

/** Filers for subscription plans */

/** Contains information about the license context for a given subscription plan price option */

/** Price data for plan pricing options */

/** Contains information on the plan price discount */

/** Definition for different price discount types */
export let SubscriptionPlanPriceDiscountType = /*#__PURE__*/function (SubscriptionPlanPriceDiscountType) {
  SubscriptionPlanPriceDiscountType["Fixed"] = "FIXED";
  SubscriptionPlanPriceDiscountType["Percentage"] = "PERCENTAGE";
  return SubscriptionPlanPriceDiscountType;
}({});

/** Union of possible plan pricing options */

/** The type of subscription plan being offered */
export let SubscriptionPlanProductType = /*#__PURE__*/function (SubscriptionPlanProductType) {
  SubscriptionPlanProductType["Consumersubscription"] = "CONSUMERSUBSCRIPTION";
  SubscriptionPlanProductType["Enterprise"] = "ENTERPRISE";
  SubscriptionPlanProductType["Enterprisepro"] = "ENTERPRISEPRO";
  SubscriptionPlanProductType["Team"] = "TEAM";
  SubscriptionPlanProductType["Udemypro"] = "UDEMYPRO";
  return SubscriptionPlanProductType;
}({});

/** contains information on the trial discount if available */

/** Status of the subscription */
export let SubscriptionStatus = /*#__PURE__*/function (SubscriptionStatus) {
  SubscriptionStatus["Active"] = "ACTIVE";
  SubscriptionStatus["Canceled"] = "CANCELED";
  SubscriptionStatus["Expired"] = "EXPIRED";
  SubscriptionStatus["Future"] = "FUTURE";
  SubscriptionStatus["Trial"] = "TRIAL";
  return SubscriptionStatus;
}({});

/** Type representing details about the trial subscription offer available for a given user and plan */

/** Topic */

/** Topic Filters for searching topics. All filters are ANDed together. */

/** Topic Group */

/** Response for topic interest update mutations */

/** Types of popularity for Topics */
export let TopicPopularityTypes = /*#__PURE__*/function (TopicPopularityTypes) {
  TopicPopularityTypes["Popular"] = "POPULAR";
  TopicPopularityTypes["Trending"] = "TRENDING";
  return TopicPopularityTypes;
}({});

/** A question and answer pair with optional link for additional context */

/** A Udemy user */

/** Represents the each notification preference of a user */

/** Represents the users notification preference */

/** Input for update for notification preferences  */

/** Response of update user notification preferences */

/** Type of notification preferences */
export let UserNotificationType = /*#__PURE__*/function (UserNotificationType) {
  UserNotificationType["All"] = "ALL";
  UserNotificationType["AssetReady"] = "ASSET_READY";
  UserNotificationType["CourseAnnouncement"] = "COURSE_ANNOUNCEMENT";
  UserNotificationType["CourseMessageNotification"] = "COURSE_MESSAGE_NOTIFICATION";
  UserNotificationType["CoursePromotion"] = "COURSE_PROMOTION";
  UserNotificationType["CourseRecommendations"] = "COURSE_RECOMMENDATIONS";
  UserNotificationType["DailyDiscussionsDigest"] = "DAILY_DISCUSSIONS_DIGEST";
  UserNotificationType["EnterpriseUbOfferings"] = "ENTERPRISE_UB_OFFERINGS";
  UserNotificationType["InstructorAnnouncement"] = "INSTRUCTOR_ANNOUNCEMENT";
  UserNotificationType["LearningInspiration"] = "LEARNING_INSPIRATION";
  UserNotificationType["LearningStats"] = "LEARNING_STATS";
  UserNotificationType["MessageNotification"] = "MESSAGE_NOTIFICATION";
  UserNotificationType["OffersPromotions"] = "OFFERS_PROMOTIONS";
  UserNotificationType["ProductAnnouncements"] = "PRODUCT_ANNOUNCEMENTS";
  UserNotificationType["Promotional"] = "PROMOTIONAL";
  UserNotificationType["VideoUploadError"] = "VIDEO_UPLOAD_ERROR";
  return UserNotificationType;
}({});

/** Shows details of the user's occupation */

/** Mutation response for occupation info update */

/** Represents the basic information of a user */

/** Represents different sizes of the same image */

/** Video lecture */

/** Length of the video in course */
export let VideoLength = /*#__PURE__*/function (VideoLength) {
  VideoLength["ExtraLong"] = "EXTRA_LONG";
  VideoLength["ExtraShort"] = "EXTRA_SHORT";
  VideoLength["Long"] = "LONG";
  VideoLength["Medium"] = "MEDIUM";
  VideoLength["Short"] = "SHORT";
  return VideoLength;
}({});

/** Mashup lecture has both video and a presentation */

/** Contains metadata about any retention streak */

/** Price option for computed price plan. Will be returned for weekly plans */

export const FeatureVariantAssignmentsDocument = `
    query FeatureVariantAssignments($featureCodes: [String!]!, $realtimeAttributes: FeatureVariantAssignmentFilters) {
  featureVariantAssignmentsByFeatureCodes(
    featureCodes: $featureCodes
    filters: $realtimeAttributes
  ) {
    featureCode
    configuration
    isInExperiment
    experimentIds
  }
}
    `;
export const useFeatureVariantAssignmentsQuery = (variables, options) => useQuery(['FeatureVariantAssignments', variables], fetcher(FeatureVariantAssignmentsDocument, variables), options);
useFeatureVariantAssignmentsQuery.getKey = variables => ['FeatureVariantAssignments', variables];
useFeatureVariantAssignmentsQuery.fetcher = (variables, options) => fetcher(FeatureVariantAssignmentsDocument, variables, options);
//# sourceMappingURL=api-platform-graphql.js.map